import React, { ReactPortal } from 'react';
import ReactDOM from 'react-dom';

export const Portal: React.FC<{
  containerId: string | null;
  getContainer?: () => HTMLDivElement;
  children: React.ReactNode;
}> = ({ containerId, getContainer, ...props }) => {
  const [portal, setPortal] = React.useState<ReactPortal | null>(null);

  React.useEffect(() => {
    if (!containerId) return;

    const inject = (): boolean => {
      const el = getContainer ? getContainer() : document.getElementById(containerId);
      if (!el) {
        return false;
      }

      setPortal(ReactDOM.createPortal(props.children, el));
      return true;
    };

    if (!inject()) {
      // DD: Add this in via timeout when containerId is still rendering
      const timer = setTimeout(inject, 10);

      return (): void => {
        clearTimeout(timer);
      };
    }

    return undefined;
  }, [containerId, props.children, getContainer]);

  if (!containerId) return <>{props.children}</>;

  return portal;
};
